var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 31,
    viewBox: "0 0 26 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4895 0.916748C11.0936 0.916748 11.5833 1.40644 11.5833 2.0105V5.65633C11.5833 6.26039 11.0936 6.75008 10.4895 6.75008C9.88545 6.75008 9.39575 6.26039 9.39575 5.65633V2.0105C9.39575 1.40644 9.88545 0.916748 10.4895 0.916748ZM3.51816 3.78939C3.94527 3.36224 4.63781 3.36221 5.06495 3.78933L7.61704 6.34124C8.0442 6.76835 8.04421 7.46089 7.6171 7.88803C7.18998 8.31519 6.49745 8.31521 6.0703 7.88809L3.51822 5.33618C3.09106 4.90907 3.09104 4.21653 3.51816 3.78939ZM17.4608 3.78936C17.8879 4.2165 17.8879 4.90902 17.4608 5.33615L14.9087 7.88824C14.4815 8.31538 13.7891 8.31538 13.362 7.88824C12.9348 7.46111 12.9348 6.76859 13.362 6.34144L15.9141 3.78936C16.3412 3.36223 17.0336 3.36223 17.4608 3.78936ZM0.645752 10.7605C0.645752 10.1564 1.13545 9.66675 1.7395 9.66675H5.38533C5.98939 9.66675 6.47908 10.1564 6.47908 10.7605C6.47908 11.3646 5.98939 11.8542 5.38533 11.8542H1.7395C1.13545 11.8542 0.645752 11.3646 0.645752 10.7605ZM9.39575 11.8354C9.39575 10.192 11.3233 9.30547 12.571 10.3749L24.9101 20.9512C26.2372 22.0888 25.4818 24.2638 23.7351 24.3336L18.1351 24.5576C17.5334 24.5817 16.9671 24.8486 16.5656 25.2973L12.7527 29.5589C11.5754 30.8747 9.39575 30.0419 9.39575 28.2762V11.8354Z",
    fill: "#031B76"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV1);
export default __webpack_public_path__ + "static/media/v1.a57aed2f8e5768ae34cef972fbc78495.svg";
export { ForwardRef as ReactComponent };